import { c as _c } from "react/compiler-runtime";
import { IconButton } from 'platform/components';
import { match } from 'ts-pattern';
import { suffixTestId, type Nullish, type TestIdProps } from 'shared/web';
import { ToolpanelType } from '../../../../types/ToolpanelType';
export type MobilePresetsButtonProps = TestIdProps & {
  isPresetActive: boolean;
  activePanel: ToolpanelType | Nullish;
  onTogglePanel: (panel: ToolpanelType) => void;
};

/**
 * Mobile preset trigger button shown in the grid header.
 *
 * Tapping slides in the presets panel in the same sidebar used by
 * Settings and Column Settings — no dialog is opened.
 *
 * Priority rules:
 * - Active preset → 'primary'
 * - Panel open, no active preset → 'secondary'
 * - Otherwise → undefined
 */
export function MobilePresetsButton(props) {
  const $ = _c(11);
  let t0;
  if ($[0] !== props) {
    t0 = () => props.onTogglePanel(ToolpanelType.presets);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleToggle = t0;
  let t1;
  if ($[2] !== props.activePanel || $[3] !== props.isPresetActive) {
    t1 = match({
      isPresetActive: props.isPresetActive,
      isPanelOpen: props.activePanel === ToolpanelType.presets
    }).with({
      isPresetActive: true
    }, _temp).with({
      isPanelOpen: true
    }, _temp2).otherwise(_temp3);
    $[2] = props.activePanel;
    $[3] = props.isPresetActive;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const priority = t1;
  let t2;
  if ($[5] !== props) {
    t2 = suffixTestId("mobilePresetsButton", props);
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== handleToggle || $[8] !== priority || $[9] !== t2) {
    t3 = <IconButton icon="action/build" priority={priority} onClick={handleToggle} data-testid={t2} />;
    $[7] = handleToggle;
    $[8] = priority;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp3() {}
function _temp2() {
  return "secondary" as const;
}
function _temp() {
  return "primary" as const;
}